import Vue from 'vue';
import moment from 'moment';

Vue.filter('formatDate', (value) => {
    if (value) {
        return moment(String(value)).format('D. MMMM YYYY');
    }

    return value;
});

Vue.filter('formatShortDateTime', (value) => {
    if (value) {
        return moment(String(value)).format('Do MMM. YYYY, [kl.] HH:mm');
    }

    return value;
});

Vue.filter('formatTimeAgo', (value) => {
    if (value) {
        const momentValue = moment(String(value));


        if (moment().diff(momentValue, 'hours') < 24) {
            return momentValue.format('HH:mm');
        }

        if (moment().diff(momentValue, 'days') <= 6) {
            const stringValue = momentValue.format('dddd');
            return stringValue.charAt(0).toUpperCase() + stringValue.slice(1);
        }

        if (moment().isSame(momentValue, 'year')) {
            return momentValue.format('Do MMM');
        }

        return momentValue.format('DD.MM.YYYY');
    }

    return value;
});



// WEBPACK FOOTER //
// ./src/global/filters/dates.js